import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import GlobalCssOverride from "./ThemeProvider";
import { AuthProvider } from './contexts/AuthContext';
import { AlertProvider } from './contexts/AlertContext';
import { ModalProvider } from './contexts/ModalContext';
import { DataProvider } from './contexts/DataContext';
import { FilterProvider } from './contexts/FilterContext';
import { UploadProvider } from './contexts/UploadContext';
import {LoaderProvider} from "./contexts/LoaderContext";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <GlobalCssOverride>
      <AuthProvider>
        <FilterProvider>
          <DataProvider>
            <AlertProvider>
              <ModalProvider>
                <UploadProvider>
                  <LoaderProvider>
                    <App />
                  </LoaderProvider>
                </UploadProvider>
              </ModalProvider>
            </AlertProvider>
          </DataProvider>
        </FilterProvider>
      </AuthProvider>
    </GlobalCssOverride>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
